export default __webpack_public_path__ + "static/media/live_stream.77e80cef.jpg";